import React from "react";
import "./FinanceTeam.scss";

const FinanceTeam = () => {
  return (
    <div className="finance-team-container">
      <div className="finance-team-member">TEAM MEMBER</div>
      <div className="finance-team-heading">
        <h2>
          The Visionaries Driving<br></br> Our Success
        </h2>
      </div>
      <div className="finance-team-img-section-main">
        <div className="finance-team-img-section">
          <div className="finance-team-img-container">
            <img src="../assets/img/finance/team-two-image1.jpg" alt="" />
          </div>
          <h3>Leslie Alexander</h3>
          <p>DESIGNER</p>
        </div>
        <div className="finance-team-img-section">
          <div className="finance-team-img-container">
            <img src="../assets/img/finance/team-two-image2.jpg" alt="" />
          </div>
          <h3>Darlene Robertson</h3>
          <p>ADMIN</p>
        </div>
        <div className="finance-team-img-section">
          <div className="finance-team-img-container">
            <img src="../assets/img/finance/team-two-image3.jpg" alt="" />
          </div>
          <h3>Darrell Steward</h3>
          <p>FOUNDER</p>
        </div>
        <div className="finance-team-img-section">
          <div className="finance-team-img-container">
            <img src="../assets/img/finance/team-two-image4.jpg" alt="" />
          </div>
          <h3>Arlene McCoy</h3>
          <p>CEO & FOUNDER</p>
        </div>
      </div>
    </div>
  );
};

export default FinanceTeam;
